// UserIdentityCell — avatar with the name over the email, the first cell of every Users table row.
import Avatar from "../shared/Avatar.js";

export default function UserIdentityCell({ name, email }: { name: string; email: string }) {
  return (
    <div className="flex items-center gap-3">
      <Avatar name={name} />
      <div className="min-w-0">
        <p className="truncate font-medium text-dm-navy">{name}</p>
        <p className="truncate text-xs text-dm-slate">{email}</p>
      </div>
    </div>
  );
}
